"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ListScreen_1 = __importDefault(require("./ListScreen"));
const ui_1 = require("@rahtab/ui");
const StoreMerchandises_1 = __importDefault(require("@rahtab/ui/dist/icons/ListEmptyIcons/StoreMerchandises"));
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ChevronLeftIcon_1 = __importDefault(require("@rahtab/ui/dist/icons/ChevronLeftIcon"));
const CategoryItem = (props) => {
    const { id, image, merchandiseCount, name, status, statusText, _onItemPress, _screenName, _providerCode: providerCode, } = props;
    const isItemActive = status === Status.active;
    return (react_1.default.createElement(ui_1.Card, { style: { marginBottom: ui_1.getSpacing() } },
        react_1.default.createElement(ui_1.ButtonBase, { onPress: () => _onItemPress && _onItemPress(props), screenName: _screenName, params: { id, providerCode } },
            react_1.default.createElement(ui_1.CardContainer, null,
                react_1.default.createElement(react_native_1.View, { style: styles.innerView },
                    react_1.default.createElement(ui_1.Image, { style: styles.image, resizeMode: "contain", source: { uri: image } }),
                    react_1.default.createElement(react_native_1.View, { style: styles.details },
                        react_1.default.createElement(react_native_1.View, { style: styles.caption },
                            react_1.default.createElement(ui_1.Text, { variant: "cardTitle", color: "primary", numberOfLines: 1, style: styles.cardTitle, margin: typeof merchandiseCount !== 'number' ? 'none' : 'default' }, name),
                            react_1.default.createElement(ui_1.Tag, { text: statusText, backgroundColor: isItemActive ? 'green' : 'default', color: isItemActive ? 'white' : 'disabled' })),
                        typeof merchandiseCount === 'number' ? (react_1.default.createElement(ui_1.Text, { color: "description", margin: "none" },
                            "\u062A\u0639\u062F\u0627\u062F \u06A9\u0627\u0644\u0627\u0647\u0627: ",
                            react_1.default.createElement(ui_1.Text, { variant: "cardTitle" }, merchandiseCount))) : null))),
            react_1.default.createElement(ui_1.CardCaption, { color: "default" },
                react_1.default.createElement(react_native_1.View, { style: styles.caption },
                    react_1.default.createElement(ui_1.Text, { margin: "none", color: "primary" }, "\u0645\u0634\u0627\u0647\u062F\u0647 \u06A9\u0627\u0644\u0627\u0647\u0627\u06CC \u0632\u06CC\u0631\u0645\u062C\u0645\u0648\u0639\u0647"),
                    react_1.default.createElement(ChevronLeftIcon_1.default, { stroke: ui_1.Colors.primary }))))));
};
function CategoriesList({ screenTitle, listData, loading, transparentLoading, refreshing, onRefresh, screenName, onItemPress, providerCode, }) {
    return (react_1.default.createElement(ListScreen_1.default, { title: screenTitle, loading: loading, transparentLoading: transparentLoading, listData: listData, refreshing: refreshing, onRefresh: onRefresh, contentContainerStyle: styles.containerStyle, ListEmptyComponent: react_1.default.createElement(ui_1.ListEmpty, { text: "\u062F\u0633\u062A\u0647\u200C\u0627\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F.", imageComponent: react_1.default.createElement(StoreMerchandises_1.default, null) }), keyExtractor: ({ id }) => id, renderItem: ({ item }) => {
            return (react_1.default.createElement(CategoryItem, Object.assign({}, item, { _onItemPress: onItemPress, _screenName: screenName, _providerCode: providerCode })));
        } }));
}
exports.default = CategoriesList;
const styles = react_native_1.StyleSheet.create({
    containerStyle: {
        paddingHorizontal: ui_1.getSpacing(),
        paddingBottom: 0,
        paddingTop: ui_1.getSpacing(),
    },
    innerView: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    image: {
        height: 53,
        width: 53,
        borderRadius: ui_1.getRadius(),
    },
    cardTitle: {
        flex: 1,
    },
    details: {
        marginLeft: ui_1.getSpacing(),
        flex: 1,
    },
    caption: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
});
// eslint-disable-next-line no-shadow
var Status;
(function (Status) {
    Status[Status["deactive"] = 0] = "deactive";
    Status[Status["active"] = 1] = "active";
})(Status || (Status = {}));
